import { fonts } from "./fonts";
import { palette } from "./palette";
export const typography = {
  global: {
    color: palette.black
  },
  h1: {
    fontFamily: fonts.secondary,
    fontSize: "40px",
    lineHeight: "44px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0"
  },
  h2: {
    fontFamily: fonts.secondary,
    fontSize: "32px",
    lineHeight: "38px",
    fontWeight: "300",
    textTransform: "uppercase",
    letterSpacing: "-0.46px"
  },
  h3: {
    fontFamily: fonts.primary,
    fontSize: "25px",
    lineHeight: "32px",
    fontWeight: "600",
    textTransform: "none",
    letterSpacing: "0"
  },
  h4: {
    fontFamily: fonts.primary,
    fontSize: "17px",
    lineHeight: "24px",
    fontWeight: "400",
    textTransform: "none",
    letterSpacing: "0"
  },
  label: {
    display: "flex",
    flexFlow: "column wrap",
    fontFamily: fonts.primary,
    fontSize: "15px",
    lineHeight: "22px",
    fontWeight: "400"
  },
  p: {
    fontFamily: fonts.primary,
    fontSize: "17px",
    lineHeight: "22px",
    fontWeight: "300"
  },
  small: {
    fontFamily: fonts.primary,
    fontSize: "12px",
    lineHeight: "16px",
    fontWeight: "300"
  },
  subheader: {
    color: palette.gray.lighter,
    fontFamily: fonts.primary,
    fontSize: "14px",
    lineHeight: "18px",
    fontWeight: "700"
  },
  footnote: {
    fontFamily: fonts.primary,
    fontSize: "11px",
    lineHeight: "14px",
    fontWeight: "300",
    fontStyle: "italic"
  },
  button: {
    fontFamily: fonts.primary,
    fontSize: "17px",
    fontWeight: 600,
    lineHeight: "22px"
  },
  input: {
    fontFamily: fonts.primary,
    fontSize: "17px",
    fontWeight: 400,
    lineHeight: "22px"
  },
  placeholder: {
    fontFamily: fonts.primary,
    fontSize: "12px",
    fontWeight: 300,
    lineHeight: "22px"
  },
  link: {
    fontFamily: fonts.primary,
    fontSize: "17px",
    fontWeight: 600,
    lineHeight: "22px"
  }
};